import React from 'react';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Treinamento from 'Interface/Treinamentos';
import { useAppSelector } from 'Store';
import { useRemoverTreinamentoMutation } from 'View/Service/Default/Treinamentos';

interface Props {
  dados: Treinamento;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerTreinamento] = useRemoverTreinamentoMutation();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const remover = async (): Promise<void> => {
    try {
      await removerTreinamento(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <div className="fs-4">
        <Link
          to={
            ['super', 'admin'].includes(usuario?.permissao || '')
              ? `/treinamentos/editar/${dados.id}`
              : `/treinamentos/visualizar/${dados.id}`
          }
          className="text-decoration-none"
        >
          {dados.titulo}
          <small className="d-block fs-6 text-muted">
            {dados.departamento?.nome}
          </small>
        </Link>
      </div>
      {['super', 'admin'].includes(usuario?.permissao || '') && (
        <div className="ms-5 fs-5 flex-grow-1 text-end">
          <Botao
            icone="trash"
            tema="danger"
            className="ms-2"
            confirmacao="Você tem certeza que deseja remover esse treinamento? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      )}
    </div>
  );
};

export default Lista;
